import { useCallback } from 'react';

import { PaperReferralApprovalResult } from '@dreryk/egabinet-referral-frontend-api';

import { printDocumentAsPdf, PromiseVoidFunction } from '@dreryk/react-common';
import { usePushBack } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';
import { useMedicalDocumentSigningStatusHandler } from '~libs.desktop.shared.medical-documentation';

type UseReferralPrintCommandSuccessHandlerOptions = {
   onPrintDone: PromiseVoidFunction | VoidFunction;
   visitId: number;
};

type ReferralPrintCommandSuccessHandler = (parameters: PaperReferralApprovalResult) => Promise<void>;

export const useReferralPrintCommandSuccessHandler = (
   options: UseReferralPrintCommandSuccessHandlerOptions
): ReferralPrintCommandSuccessHandler => {
   const push = usePushBack();
   const handleDocumentSigningStatus = useMedicalDocumentSigningStatusHandler();

   return useCallback(
      async ({ file, signingStatus }) => {
         await printDocumentAsPdf({
            base64: file.data,
         });
         handleDocumentSigningStatus(signingStatus);

         await options.onPrintDone();
         push(
            visitPaths.getVisitInterviewPath({
               params: {
                  visitId: options.visitId,
               },
            })
         );
      },
      [handleDocumentSigningStatus, options, push]
   );
};
